import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { PaymentService } from 'src/app/services/payment.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

@Component({
    selector: 'app-state-wise-amount-balance',
    templateUrl: './state-wise-amount-balance.component.html',
    styleUrls: ['./state-wise-amount-balance.component.scss'],
    standalone: false
})
export class StateWiseAmountBalanceComponent implements OnInit {
  readonly columns: TableColumn[] = [
    { field: 'state.state_name', header: 'State Name' },
    { field: 'denomination', header: 'Denomination' },
    { field: 'stamp_type', header: 'Stamp Type' },
    { field: 'balance', header: 'Balance Amount' },
    { field: 'action', header: 'Action', toggleable: false },
  ];

  accountId:any = ''
  branches: any;
  amountbalance : any;
  selectedDate: any;
  amountbalanceData: any = [];
  pageNo: number = 1;
  totalRecords: number = 10;
  displayBranch!: any;
  selectedStateWallet: any;
  enteredBalance: any;
  isBalanceAdded: boolean;
  addBalanceForm: FormGroup;
  states: any = [];
  walletFilter: any = {
    state_ids: [],
  };

  constructor(private storageService: StorageService,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private userDashboardService: UserDashboardService,
    private cookieService: CookieService,
    private paymentService: PaymentService,
    private modalService: NgbModal,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.userDashboardService.getBranchList().subscribe((res: any) => {
      this.branches = res['content'];
      this.displayBranch = this.storageService.getBranch() || null;
      this.displayBranch = this.displayBranch.name;
      this.cdr.detectChanges();
    })

    this.addBalanceForm = this.formBuilder.group({
      amount: new FormControl(null, [Validators.required])
    });

    this.accountId = this.storageService.getAccountId();
  }

  ngOnInit(): void {
    this.storageService.accountId$.subscribe((id) => {
      this.accountId = id;
    });
    this.getStates()
    this.getStateWallet()
  }

  getStates() {
    this.paymentService.getState().subscribe((res: any) => {
      this.states = res['content'];
      this.cdr.detectChanges();
    })
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  export() {
    this.exportExcelService.convertToExcel(this.amountbalanceData, 'amountbalanceData');
  }

  onPageChange(event: any) {

  }

  viewStateWallet(balance: any): void {
    this.router.navigate(['/doqfy/wallet/expenditure', balance.id]);
  }

  getStateWallet() {
    this.paymentService.getStateWallet().subscribe((resp) => {
      if (resp.status == 200) {
        this.getBalance(this.accountId);
        this.amountbalanceData = resp.content;
        this.totalRecords = resp.pagination.total_records;
        this.cdr.detectChanges();
      }
    })
  }

  openAddBalance(content, data) {
    this.enteredBalance = ''
    this.selectedStateWallet = data
    this.isBalanceAdded = true
    this.modalService
      .open(content, {
        size: "lg",
        ariaLabelledBy: "modal-basic-title",
      })
      .result.then(
        (result) => { },
        (reason) => { }
      );
  }

  addBalance() {
    if (this.enteredBalance === undefined || this.enteredBalance === '') {
      this.isBalanceAdded = false
      return
    } else {
      let params = [
        {
          "state_id": this.selectedStateWallet.state.id,
          "denomination": this.selectedStateWallet.denomination,
          "stamp_type": this.selectedStateWallet.stamp_type,
          "amount": this.enteredBalance
        }
      ]

  

      this.paymentService.addNewStateWallet(params).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.modalService.dismissAll()
            this.messageService.add({ severity: 'success', summary: 'Balance added successfully!' });
            this.getStateWallet()
            this.enteredBalance = ''
          }
        },
        (error: any) => {
         
          this.messageService.add({ severity: 'error', summary: error.error.message });
        });
    }

  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) || event.keyCode == 45) {
      event.preventDefault();
    } else if (event.target.value === '0') {
      event.preventDefault();
    }
  }

  onStateChanage(event) {
    this.walletFilter.state_ids = []
    if (event.value !== null) {
      this.walletFilter.state_ids.push(event.value);
    this.paymentService.getStateWallet(this.walletFilter).subscribe((resp) => {
      if (resp.status == 200) {
        this.amountbalanceData = resp.content;
        this.totalRecords = resp.pagination.total_records;
        this.cdr.detectChanges();
      }
    })
    } else {
      this.getStateWallet()
    }

  }

  getBalance(id) {
    this.paymentService.getBalance(id).subscribe((resp) => {
      if (resp.status == 200) {
        this.amountbalance = resp.content.balance;
        this.cdr.detectChanges();
      }
    })
  }

}
